var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"py-1 my-2"},[_c('v-col',{staticClass:"py-0"},[_c('h3',{staticClass:"pb-1"},[_vm._t("default")],2),_c('v-divider')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }